import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import SectionTitle from "../../components/Common/SectionTitle";
import Marquee from "react-fast-marquee";
import gridImg1 from "../../assets/img/_MG_9703.jpg";
import gridImg2 from "../../assets/img/_MG_9677.jpg";
import { AnnouncementService } from "../../services/AnnouncementService";
import { FaLightbulb, FaTrophy, FaUsers, FaHandshake, FaHandsHelping, FaShieldAlt, FaCheckCircle } from "react-icons/fa";

function About() {
  const [state, setState] = useState(true);

  const counters = [
    {
      countNum: 90,
      countTitle: "Completed Projects",
      counterPrefix: "+",
    },
    {
      countNum: 4,
      countTitle: "Ongoing Projects",
      counterPrefix: "+",
    },
    {
      countNum: 12,
      countTitle: "Upcoming Projects",
      counterPrefix: "+",
    },
  ];

  const [items, setItems] = useState([]);
  const [isLoading, setLoading] = useState(true);

  const getAnnoucements = () => {
    AnnouncementService.get(0)
      .then((response) => {
        setLoading(false);
        if (response.data.success) {
          const payload = response.data.data;
          setItems(payload.page);
        }
      })
      .catch((ex) => {
        console.log(ex);
        setLoading(false);
      });
  };

  useEffect(() => {
    getAnnoucements();
  }, []);

  return (
    <div
      id="rs-about"
      className="rs-about style2 pt-94 pb-100 md-pt-64 md-pb-70"
    >
      {items && items.length > 0 ? (
        <div className="annoucements d-none d-sm-block">
          <Marquee pauseOnHover={true} delay={2}>
            {items.map((item, idx) => {
              return <h3 key={idx}>{item.title}</h3>;
            })}
          </Marquee>
        </div>
      ) : (
        <></>
      )}
      <div className="container">
        <div className="row">
          <div className="col-lg-5 pr-64 md-pr-14 md-mb-50">
            <div className="about-intro">
              {/* Section Title Start */}
              <SectionTitle
                sectionClass="sec-title mb-40"
                subtitleClass="sub-title primary"
                titleClass="title mb-22"
                title="About Syrol"
                descClass="desc big"
                // secondDescClass="desc mt-20"
                // secondDescription="We specialize in Custom Software Development, Mobile App Development (iOS, Android), Web Application Development, Enterprise Software Solutions, Cloud-Based Solutions, Payment Gateway, Financial Management Software, Digital Wallet Solutions, Banking platforms, E-commerce, Teleco Solutions, Cybersecurity Solutions, Blockchain Technology, Rigorous Software Maintenance, Security and Performance Optimization Solutions and more.                "
                description="Syrol is among the leading IT service providers in Nigeria, helping businesses thrive in the digital age. Our expert team crafts tailored scalable software development, performance, and security solutions that drive growth and stability, enhance productivity, and streamline operations. We transform businesses through innovative software development, cyber security, artificial intelligence, performance optimization, standard system design, and operation solutions, keeping user experience, maximum security, high performance, and stability in mind."
              />
              {/* Section Title End */}
              <div className="btn-part">
                <Link to="/about-us" className="readon2">
                  Read More
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-7 ml--40 md-ml-0">
            
            <div className="row grid-area">
              <div className="col-md-6 sm-mb-30">
                <div className="image-grid">
                  <img src={gridImg1} alt="grid img" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="image-grid">
                  <img src={gridImg2} alt="grid img" />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 pt-12">
                <h3 style={{ padding: "0", margin: "0 0 20px 0" }}>Why Choose Syrol?</h3>
                <div className="row">
                  <div className="col-lg-6 col-md-6 mb-3">
                    <div className="services-part d-flex align-items-start">
                      <div className="services-icon me-3" style={{ minWidth: "32px" }}>
                        <FaCheckCircle size={22} style={{ color: "#f4bf00" }} />
                      </div>
                      <div className="services-text">
                        <p className="mb-0" style={{ fontSize: "14px", lineHeight: "1.6" }}>
                          Proven track record of delivering high-quality software solutions.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <div className="services-part d-flex align-items-start">
                      <div className="services-icon me-3" style={{ minWidth: "32px" }}>
                        <FaCheckCircle size={22} style={{ color: "#f4bf00" }} />
                      </div>
                      <div className="services-text">
                        <p className="mb-0" style={{ fontSize: "14px", lineHeight: "1.6" }}>
                          Staying ahead of the curve with the latest technologies and trends.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <div className="services-part d-flex align-items-start">
                      <div className="services-icon me-3" style={{ minWidth: "32px" }}>
                        <FaCheckCircle size={22} style={{ color: "#f4bf00" }} />
                      </div>
                      <div className="services-text">
                        <p className="mb-0" style={{ fontSize: "14px", lineHeight: "1.6" }}>
                          Flexible and adaptable approach to meet changing business needs.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <div className="services-part d-flex align-items-start">
                      <div className="services-icon me-3" style={{ minWidth: "32px" }}>
                        <FaCheckCircle size={22} style={{ color: "#f4bf00" }} />
                      </div>
                      <div className="services-text">
                        <p className="mb-0" style={{ fontSize: "14px", lineHeight: "1.6" }}>
                          Collaborative and responsive approach to ensure satisfaction.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-lg-6 col-md-6 mb-3">
                    <div className="services-part d-flex align-items-start">
                      <div className="services-icon me-3" style={{ minWidth: "32px" }}>
                        <FaCheckCircle size={22} style={{ color: "#f4bf00" }} />
                      </div>
                      <div className="services-text">
                        <p className="mb-0" style={{ fontSize: "14px", lineHeight: "1.6" }}>
                          Competitive pricing without compromising on quality.
                        </p>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 pt-4">
                <h3 style={{ padding: "0", margin: "0 0 30px 0" }}>Our Core Values</h3>
                <div className="row">
                  <div className="col-lg-6 col-md-6 mb-4">
                    <div className="services-part d-flex align-items-start">
                      <div className="services-icon me-3" style={{ minWidth: "60px" }}>
                        <FaLightbulb size={40} style={{ color: "#f4bf00" }} />
                      </div>
                      <div className="services-text">
                        <h4 className="title mb-2" style={{ fontSize: "18px", fontWeight: "600" }}>Innovation</h4>
                        <p className="services-txt mb-0" style={{ fontSize: "14px", lineHeight: "1.5" }}>
                          We embrace creativity and cutting-edge technology to deliver solutions that drive progress and transformation.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 mb-4">
                    <div className="services-part d-flex align-items-start">
                      <div className="services-icon me-3" style={{ minWidth: "60px" }}>
                        <FaTrophy size={40} style={{ color: "#f4bf00" }} />
                      </div>
                      <div className="services-text">
                        <h4 className="title mb-2" style={{ fontSize: "18px", fontWeight: "600" }}>Excellence</h4>
                        <p className="services-txt mb-0" style={{ fontSize: "14px", lineHeight: "1.5" }}>
                          We are committed to delivering high-quality products, services, and training that exceed expectations and set industry standards.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 mb-4">
                    <div className="services-part d-flex align-items-start">
                      <div className="services-icon me-3" style={{ minWidth: "60px" }}>
                        <FaUsers size={40} style={{ color: "#f4bf00" }} />
                      </div>
                      <div className="services-text">
                        <h4 className="title mb-2" style={{ fontSize: "18px", fontWeight: "600" }}>Customer Success</h4>
                        <p className="services-txt mb-0" style={{ fontSize: "14px", lineHeight: "1.5" }}>
                          We prioritize our clients' growth and satisfaction by building solutions that are tailored, scalable, and impactful.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 mb-4">
                    <div className="services-part d-flex align-items-start">
                      <div className="services-icon me-3" style={{ minWidth: "60px" }}>
                        <FaHandshake size={40} style={{ color: "#f4bf00" }} />
                      </div>
                      <div className="services-text">
                        <h4 className="title mb-2" style={{ fontSize: "18px", fontWeight: "600" }}>Integrity</h4>
                        <p className="services-txt mb-0" style={{ fontSize: "14px", lineHeight: "1.5" }}>
                          We uphold transparency, honesty, and strong ethical principles in all our operations and relationships.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 mb-4">
                    <div className="services-part d-flex align-items-start">
                      <div className="services-icon me-3" style={{ minWidth: "60px" }}>
                        <FaHandsHelping size={40} style={{ color: "#f4bf00" }} />
                      </div>
                      <div className="services-text">
                        <h4 className="title mb-2" style={{ fontSize: "18px", fontWeight: "600" }}>Collaboration</h4>
                        <p className="services-txt mb-0" style={{ fontSize: "14px", lineHeight: "1.5" }}>
                          We believe in the power of teamwork and partnerships to achieve greater impact and success together.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 mb-4">
                    <div className="services-part d-flex align-items-start">
                      <div className="services-icon me-3" style={{ minWidth: "60px" }}>
                        <FaShieldAlt size={40} style={{ color: "#f4bf00" }} />
                      </div>
                      <div className="services-text">
                        <h4 className="title mb-2" style={{ fontSize: "18px", fontWeight: "600" }}>Security & Responsibility</h4>
                        <p className="services-txt mb-0" style={{ fontSize: "14px", lineHeight: "1.5" }}>
                          We prioritize data protection and cybersecurity, ensuring the safety and privacy of all our stakeholders.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {items && items.length > 0 ? (
        <div className="annoucements pt-20 mt-20  d-sm-none  d-block">
          <Marquee pauseOnHover={true} delay={2}>
            {items.map((item, idx) => {
              return <h3 key={idx}>{item.title}</h3>;
            })}
          </Marquee>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}

export default About;
